import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default, { forwardRef } from 'react';
import { classNames } from '../../helpers/classnames.js';

var Button = forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.variant, variant = _c === void 0 ? 'outlined' : _c, disabled = _a.disabled, startIcon = _a.startIcon, endIcon = _a.endIcon, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, href = _a.href, props = __rest(_a, ["className", "children", "size", "variant", "disabled", "startIcon", "endIcon", "fullWidth", "href"]);
    var buttonClassNames = classNames('dsb_button', "dsb_button__".concat(size), "dsb_button__".concat(variant), {
        'dsb_button__start-icon': !!startIcon,
        'dsb_button__end-icon': !!endIcon,
        'dsb_button__icon-button': !children,
        dsb_button__disabled: disabled,
        'dsb_button__full-width': fullWidth,
        dsb_button__link: !!href,
    }, className);
    if (href) {
        return (React__default.createElement("a", __assign({}, props, { href: href, className: buttonClassNames, ref: ref }),
            startIcon && React__default.createElement("div", { className: "dsb_button-start-icon" }, startIcon),
            children,
            endIcon && React__default.createElement("div", { className: "dsb_button-end-icon" }, endIcon)));
    }
    return (React__default.createElement("button", __assign({ "data-testid": "Button" }, props, { className: buttonClassNames, disabled: disabled, ref: ref }),
        startIcon && React__default.createElement("div", { className: "dsb_button-start-icon" }, startIcon),
        children,
        endIcon && React__default.createElement("div", { className: "dsb_button-end-icon" }, endIcon)));
});

export { Button };
